import React, { useState } from "react";
import Box from "@mui/material/Box";
import SfLogo from "../../images/SF_Logo.png";
import Login from "./Login";
import Idlogin from "./Idlogin";
import MobileLogin from "./MobileLogin";
import { useDispatch, useSelector } from "react-redux/es/exports";
import SfTeam from "../../images/sundaramteam.png";
import Pagelayout from "../Pagelayout/Pagelayout";
import "./LoginPage.css";
import Slider from "./Slider";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";
import { BranchAction } from "../Store/Branch";
import { loginAction } from "../Store/LoginAuth";
import IdleTimer from "../IdleTimerContainer/IdleTimer ";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
const LoginPage = () => {
  const deploymentDate = process.env.REACT_APP_DEPLOYMENT_DATE;
  const loginPages = useSelector((state) => state.login.loginScreen);
  const EmployeeIDPage = useSelector((state) => state.login.EmployeeIDScreen);
  const MobilePage = useSelector((state) => state.login.MobileScreen);
  const randomKey = useSelector((state) => state.branch.randomKey);
  const [autoLogoutDialog, setAutoLogoutDialog] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [timer, setTimer] = useState(1800000);

  const handleIdle = () => {
    // Handle idle state here (e.g., show a modal, log out the user, etc.)
    console.log("User is idle");
    logoutHandler();
    setAutoLogoutDialog(true);
  };
  const OkHandler = () => {
    setAutoLogoutDialog(false);
  };

  const logoutHandler = () => {
    sessionStorage.removeItem("ConfigDt");
    sessionStorage.removeItem("randomKey");
    dispatch(BranchAction.updateBranch([]));
    dispatch(BranchAction.updateUserName(""));
    dispatch(BranchAction.resetHeaderValues());
    navigate("/stlap/login", { replace: true });
    dispatch(loginAction.updateLogin(false));
    dispatch(loginAction.updateEmployeeIDScreen(true));
    dispatch(loginAction.updateMobileScreen(false));
    Cookies.remove("Token");
  };
  const Lgp = (
    <>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#004A92",
          height: "3.5rem",
        }}
      >
        <Box
          sx={{
            marginLeft: "0.5rem",
            height: "3.5rem",
            backgroundImage: `url(${SfLogo})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "left",
            backgroundSize: "15rem",
          }}
        ></Box>
      </Box>
      <div className="contain">
        <Box
          className="add"
          sx={{
            borderRadius: "14px",
          }}
        >
          <Slider />
        </Box>
        {loginPages && <Login />}
        {EmployeeIDPage && <Idlogin />}
        {MobilePage && <MobileLogin />}
      </div>
      <Box
        sx={{
          backgroundColor: "#004A92",
          width: "100%",
          color: "white",
          position: "absolute",
          bottom: 0,
          height: "2rem",
          paddingTop: "0.3rem",
          textAlign: "center",
        }}
      >
        {`© 2023.Sundaram Home Finance Limited. ${new Date().getFullYear()}.  Last Deployment${deploymentDate}`}
      </Box>
      <Dialog
        open={autoLogoutDialog}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Information</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            You have been Idle for More than 30 Minutes
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={OkHandler}>Ok</Button>
        </DialogActions>
      </Dialog>
    </>
  );
  return sessionStorage.getItem("ConfigDt") === null ? (
    Lgp
  ) : JSON.parse(
      CryptoJS.AES.decrypt(
        sessionStorage.getItem("ConfigDt"),
        atob(sessionStorage.getItem("randomKey"))
      ).toString(CryptoJS.enc.Utf8)
    ) ? (
    <>
      <Pagelayout />
      <IdleTimer timeout={timer} onIdle={handleIdle} />
    </>
  ) : (
    Lgp
  );
};

export default LoginPage;
